var _path, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgLogoKaia = function SvgLogoKaia(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 288,
    height: 80,
    fill: "none",
    viewBox: "0 0 288 80",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "logo-kaia_svg__a",
    width: 92,
    height: 33,
    x: 98,
    y: 23,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M189.439 24H98.506v32h90.933z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#BFF009",
    mask: "url(#logo-kaia_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M158.357 34.992h-4.805v19.116h4.805zM176.312 34.793c-4.929-.007-8.376 3.473-8.991 8.407-.509 3.855.9 8.012 3.97 10.021 2.74 1.89 7.023 1.765 9.337-.857v1.74h4.769v-9.36c0-5.496-4.068-9.95-9.085-9.95m0 14.801c-2.444 0-4.424-2.171-4.424-4.847s1.982-4.847 4.424-4.847 4.424 2.171 4.424 4.847-1.981 4.847-4.424 4.847M134.634 32.695c0-1.156.86-2.097 1.915-2.097h3.426v-5.105h-3.426c-3.63 0-6.574 3.225-6.574 7.202 0 1.038.202 2.025.563 2.915-2.819 1.306-4.691 4.08-5.127 7.59-.51 3.855.9 8.013 3.97 10.021 2.739 1.89 7.023 1.766 9.337-.857v1.741h4.769V34.793h-6.936c-1.055 0-1.917-.941-1.917-2.098m4.19 7.205v4.847c0 2.678-1.982 4.848-4.424 4.848s-4.425-2.172-4.425-4.848 1.982-4.847 4.425-4.847zM155.97 25.493a2.43 2.43 0 0 0-1.915.87q-.757.872-.757 2.099c0 .817.252 1.55.757 2.118q.758.85 1.915.85c.772 0 1.438-.283 1.933-.85q.74-.85.742-2.118c0-.846-.247-1.518-.742-2.098q-.74-.87-1.933-.87M114.361 34.992l-6.043 7.086h-1.039V25.493h-4.732v28.614h4.732v-7.086h1.039l6.043 7.086h5.779l-8.176-9.559 8.176-9.556z"
  }))));
};
export default SvgLogoKaia;